module.exports = __webpack_public_path__ + "static/media/Minor Changes_1576155867553.91280df9.mp4";